import { createSlice } from '@reduxjs/toolkit';

export const plaidSlice = createSlice({
  name: 'plaid',
  initialState: { linkSessionId: '' },
  reducers: {
    setLinkSessionId: (state, action) => {
      state.linkSessionId = action.payload;
    },
  },
});

export const { setLinkSessionId } = plaidSlice.actions;
